/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanBarcodeClassicIcon16Light } from './ScanBarcodeClassicIcon16Light';
import { ScanBarcodeClassicIcon16Regular } from './ScanBarcodeClassicIcon16Regular';
import { ScanBarcodeClassicIcon16Solid } from './ScanBarcodeClassicIcon16Solid';
import { ScanBarcodeClassicIcon20Light } from './ScanBarcodeClassicIcon20Light';
import { ScanBarcodeClassicIcon20Regular } from './ScanBarcodeClassicIcon20Regular';
import { ScanBarcodeClassicIcon20Solid } from './ScanBarcodeClassicIcon20Solid';
import { ScanBarcodeClassicIcon24Regular } from './ScanBarcodeClassicIcon24Regular';
import { ScanBarcodeClassicIcon24Solid } from './ScanBarcodeClassicIcon24Solid';
import { ScanBarcodeClassicIcon32Regular } from './ScanBarcodeClassicIcon32Regular';
import { ScanBarcodeClassicIcon64Regular } from './ScanBarcodeClassicIcon64Regular';
var sizes = {
    16: {
        light: ScanBarcodeClassicIcon16Light,
        regular: ScanBarcodeClassicIcon16Regular,
        solid: ScanBarcodeClassicIcon16Solid,
    },
    20: {
        light: ScanBarcodeClassicIcon20Light,
        regular: ScanBarcodeClassicIcon20Regular,
        solid: ScanBarcodeClassicIcon20Solid,
    },
    24: {
        regular: ScanBarcodeClassicIcon24Regular,
        solid: ScanBarcodeClassicIcon24Solid,
    },
    32: {
        regular: ScanBarcodeClassicIcon32Regular,
    },
    64: {
        regular: ScanBarcodeClassicIcon64Regular,
    },
};
export var ScanBarcodeClassicIcon = forwardRef('ScanBarcodeClassicIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
